const booleanFormatString = {
    singleLetter: 'Y/N',
    singleDigit: '1/0',
    trueFalse: 'True/False',
    yesNo: 'Yes/No'
};

export default booleanFormatString;
